import React, { createContext, useState, useEffect } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { getUserProfile } from '../apiCall/userApiCall';

// Create Context
export const AuthContext = createContext();

// Provider Component
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [isTrial, setIsTrial] = useState(true)
  const [isSubscribed, setIsSubscribed] = useState(true)
  const [userDetails, setIUserDetails] = useState({})
const [showSubscriptioModal,setShowSubscriptionModal]=useState(false)

  // Load token & userId from AsyncStorage on app start
  useEffect(() => {
    const loadAuthData = async () => {
      try {
        const storedToken = await AsyncStorage.getItem('key');
        const storedUserId = await AsyncStorage.getItem('id');
        if (storedToken) setToken(storedToken);
        if (storedUserId) setUserId(storedUserId);
      } catch (error) {
        console.error('Error loading auth data:', error);
      } finally {
        setLoading(false);
      }
    };
    loadAuthData();
  }, []);


  const saveUserDetails = async (userDetails) => {
    try {
      const res = await getUserProfile()
      setIsTrial(res.data.is_trail !== "0");
      setIsSubscribed(res.data.is_subscribe !== "0");
      setIUserDetails(res.data)
    } catch (error) {
      console.error('Error saving user details:', error);
    }
  };
  // Save auth data to AsyncStorage
  const login = async (tokenValue, userIdValue) => {
    try {
      await AsyncStorage.setItem('key', tokenValue);
      await AsyncStorage.setItem('id', userIdValue);
      setToken(tokenValue);
      setUserId(userIdValue);
    } catch (error) {
      console.error('Error saving auth data:', error);
    }
  };

  // Remove auth data (logout)
  const logout = async () => {
    try {
      await AsyncStorage.removeItem('key');
      await AsyncStorage.removeItem('id');
      setToken(null);
      setUserId(null);
    } catch (error) {
      console.error('Error clearing auth data:', error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        userId,
        loading,
        login,
        logout,
        isAuthenticated: !!token,
        isLoggedIn, setIsLoggedIn,
        isSubscribed, setIsSubscribed,
        isTrial, setIsTrial,
        userDetails, setIUserDetails, saveUserDetails,
        showSubscriptioModal,setShowSubscriptionModal
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
